import { tString } from '../../../logical/data-type.js';
import { columnManager } from '../manager.js';
export const textColumnTypeName = 'text';
export const textPureColumnConfig = columnManager.register(textColumnTypeName, {
    name: 'Plain-Text',
    type: () => tString.create(),
    defaultData: () => ({}),
    cellToString: data => data ?? '',
    cellFromString: data => {
        return {
            value: data,
        };
    },
    cellToJson: data => data ?? null,
});
//# sourceMappingURL=define.js.map